import { object, string } from 'yup';

import { ICheckFolderNameDTO } from '@interfaces/portal/dto/foldersManagementDTO';

import { getMaxLengthErrMsg, validationErrMessages } from '@constants/validationConstants';
import { MAX_70_LENGTH } from '@constants/validationMessages';

interface IGetSchema {
	handleCheckFolderName: (data: ICheckFolderNameDTO) => Promise<void>;
	projectId: string;
	parentFolderId: string | null;
	folderId: string | null;
}

export const getSchema = ({
	handleCheckFolderName,
	projectId,
	parentFolderId,
	folderId,
}: IGetSchema) => {
	return object({
		folderName: string()
			.trim()
			.default('')
			.max(MAX_70_LENGTH, getMaxLengthErrMsg('Folder Name', MAX_70_LENGTH))
			.required(validationErrMessages.folderName)
			.test('check unique name',
				async (value, context) => {
					if (!value) return false;

					try {
						await handleCheckFolderName({ name: value, projectId, parentFolderId, folderId });

						return true;
					} catch (err: any) {
						if (err?.errors?.length && err.errors[0].message) {
							return context.createError({ message: err.errors[0].message });
						}

						return context.createError({ message: 'Folder name must be unique' });
					}
				},
			),
	});
};
